import { ArdoqId, Entity } from '@ardoq/api-types';
import { ComponentIdAndTypeName } from '@ardoq/data-model';

export const toId = ({ _id }: Entity): ArdoqId => _id;
export const toIds = (entities: Entity[]): ArdoqId[] => entities.map(toId);
export const toIdSet = (entities: Entity[]): Set<ArdoqId> =>
  new Set(toIds(entities));
export const toComponentIdAndTypeName = <
  T extends { _id: ArdoqId; typeName: string },
>(
  components: T[]
): ComponentIdAndTypeName[] =>
  components.map(({ _id, typeName }) => ({
    id: _id,
    typeName,
  }));
